module.exports = __webpack_public_path__ + "img/briefcase.e6ea89a9.svg";